import { getFetchedDataPayload } from '@vista-digital/utilities';
import { loyaltyDomainStore } from '../../../store';
export const getMemberRewards = () => {
    return getFetchedDataPayload(loyaltyDomainStore.data.memberRewards);
};
//# sourceMappingURL=get-member-rewards.js.map